import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useManagerProfile } from "./ManagerProfileHook";
// Set the default state values for each context
export const ManagerProfileContext = /*#__PURE__*/createContext({});
export const ManagerProfileContextProvider = ({
  children
}) => {
  const managerProfile = useManagerProfile();
  const {
    stateTracker
  } = useDevLogging();
  const managerProfileContext = useMemo(() => {
    stateTracker.trackState({
      managerProfile: managerProfile.managerProfile
    });
    return {
      ...managerProfile
    };
  }, [managerProfile.managerProfile]);
  return /*#__PURE__*/React.createElement(ManagerProfileContext.Provider, {
    value: managerProfileContext
  }, children);
};
export const useManagerProfileContext = () => {
  return useContext(ManagerProfileContext);
};
ManagerProfileContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};